import React, { Component } from 'react';
import SearchBar from 'components/shared/navigation/SearchBar';
import ContractorsInvoicesTable from 'components/admin/contractors-invoices/ContractorsInvoicesTable';
import ContractorsInvoicesTabs from 'components/admin/contractors-invoices/ContractorsInvoicesTabs';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import { getCurrentUser } from 'selectors/authentication';
import { usersUtil, TYPES } from 'services/utils/users-util';
import VendorsInvoicesTable from 'components/admin/contractors-invoices/VendorsInvoicesTable';
import { connect } from 'react-redux';
import { searchTextSelector } from 'components/admin/contractors-invoices/store/selectors';
import {
  changePageRequest,
  changeSearchText,
  changeVendorInvoicesPageRequest,
  initSearchFilters,
} from 'components/admin/contractors-invoices/store/actions';
import { getCurrentInvoicesTab } from 'selectors/admin/work-orders/work-orders';
import { loadWorkOrdersRequest } from 'actions/admin/work-orders/work-orders';

class ContractorsInvoices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 1,
    };
  }

  handleSearch = (text) => {
    if (this.state.currentTab === 1) {
      if (this.props.currentInvoicesTab === 1) {
        this.props.onContractorInvoicesSearch(text);
      } else {
        this.props.onWorkOrdersWithoutInvocesSearch({
          page: 1,
          withoutContractorInvoice: true,
          jobNumber: text,
        });
      }
    } else {
      this.props.onVendorInvoicesSearch(text);
    }
  };

  handleSearchTextChange = (text) => {
    this.props.onSearchTextChange(text);
  };

  handleSearchTextClear = () => {
    this.props.onSearchTextChange('');
  };

  handleTabChange = (value) => {
    // Clear search text input
    this.props.onSearchTextChange('');
    this.props.onInitSearchFilters();
    this.setState({ currentTab: value });
  };

  renderForAdmin = () => {
    return (
      <div className="content-container">
        <SearchBar>&nbsp;</SearchBar>
        <ContractorsInvoicesTable />
      </div>
    );
  };

  renderForContractor = () => {
    return (
      <div className="content-container">
        <SearchBar
          searchPlaceHolder="Search by Job #"
          searchText={this.props.searchText}
          onClearText={this.handleSearchTextClear}
          onSearch={this.handleSearch}
          onSearchTextChange={this.handleSearchTextChange}
        >
          <NavigationBar
            items={[
              {
                id: 1,
                title: 'Spackle Invoices',
              },
              {
                id: 2,
                title: 'Vendors',
              },
            ]}
            onSelected={this.handleTabChange}
          />
        </SearchBar>

        {this.state.currentTab === 1 && <ContractorsInvoicesTabs />}
        {this.state.currentTab === 2 && <VendorsInvoicesTable />}
      </div>
    );
  };

  render() {
    return (
      <div className="invoices">
        <div className="full-title">Contractors Invoices</div>
        {usersUtil.isAdmin(this.props.currentUser) ||
        usersUtil.hasType(this.props.currentUser, TYPES.GENERAL_CONTRACTOR)
          ? this.renderForAdmin()
          : this.renderForContractor()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: getCurrentUser(state),
    searchText: searchTextSelector(state),
    currentInvoicesTab: getCurrentInvoicesTab(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onContractorInvoicesSearch: (text) => {
    dispatch(changePageRequest(1, text));
  },
  onSearchTextChange: (text) => {
    dispatch(changeSearchText(text));
  },
  onInitSearchFilters: () => {
    dispatch(initSearchFilters());
  },
  onVendorInvoicesSearch: (text) => {
    dispatch(changeVendorInvoicesPageRequest(1, text));
  },
  onWorkOrdersWithoutInvocesSearch: (criteria) => {
    dispatch(loadWorkOrdersRequest(criteria));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractorsInvoices);



// WEBPACK FOOTER //
// ./src/components/admin/contractors-invoices/ContractorsInvoices.js